
    <input type='time' value='{{timeField}}' title="{{tooltip}}" [style.color]="textColor" placeholder="hh:mm"
           (click)='open()'/>
  